<template>
    <div class="main-container">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <airLeadInfoPopup :settings='airLeadInfoPopupSettings'></airLeadInfoPopup>
        <div class="airlead-header">
            <div class="fetch-new-wrapper"><b-form-checkbox v-model="hideClosed">{{translate('airLeadHideLeads')}}</b-form-checkbox></div>
            <div class="fetch-all-wrapper"><b-form-checkbox v-model="fetchAll">{{translate('airLeadShowAllLeads')}}</b-form-checkbox></div>
        </div>
        <div class="airleads-container">
            <table class="airleads-table">
                <tr class="table-header">
                    <td style="width: 50px; min-width: 50px; color: black;  text-decoration: none;" class="first-col">ID</td>
                    <td style="min-width: 150px; width: 150px;">{{translate('airLeadDashboardDate')}}</td>
                    <td style="width: 200px; min-width: 150px">{{translate('airLeadSubmittedBy')}}</td>
                    <td style="min-width: 30px; width: 30px;">{{translate('airLeadDashboardType')}}</td>
                    <td style="min-width:30px; width: 30px;">{{translate('airLeadDashboardStatus')}}</td>
                    <td style="min-width: 200px;">{{translate('airLeadDashboardStatusNotes')}}</td>
                    <td style="width: 80px">Qty</td>
                    <td style="width: 80px">$</td>
                    <td style="min-width: 150px; width: 150px;">{{translate('airLeadDashboardLastActionDate')}}</td>
                    <td style="width: 200px; min-width: 160px">{{translate('airLeadDashboardActionBy')}}</td>
                    <td style="width: 50px; min-width: 50px;" class="last-col"></td>
                </tr>
                <tr class="table-row" v-for="(item, index) in leads" :key="index"
                    :class="{finished:isLeadFinished(item.status)}">
                    <td style="cursor: pointer" class="first-col" @click="showLeadInfo(item)">{{ item.id }}</td>
                    <td>{{ item.created_at | moment("MM/DD/YYYY HH:mm") }}</td>
                    <td>{{ item.creator.first_name }} {{ item.creator.last_name }}</td>
                    <td style="text-align: center">{{ getTypeText(item.type) }}</td>
                    <td @click="onStatusClick(item)" style="text-align: center; cursor: pointer" class="status-cell">
                        <img src="@/assets/icons/ic_cogs.svg" v-if="item.status == 'new'">
                        <img src="@/assets/icons/ic_checkbox_marked_airlead.svg" v-if="item.status == 'closed'">
                        <img src="@/assets/icons/ic_x_airlead.svg"  v-if="item.status == 'not_closed'">
                        <img src="@/assets/icons/ic_not_qualified.svg" v-if="item.status == 'not_qualified'">
                        <b-dropdown :ref="`status_dropdown_${item.guid}`" class="status-dropdown"
                                    toggle-class="status-dropdown-toggle" no-caret variant="link">
                            <b-dropdown-item @click.stop="onStatusSelected(item, 'new')" v-if="item.status != 'new'">
                                <img src="@/assets/icons/ic_cogs.svg"><span>{{translate('airLeadDashboardSalesFollowUp')}}</span>
                            </b-dropdown-item>
                            <b-dropdown-item @click.stop="onStatusSelected(item, 'not_closed')"
                                             v-if="item.status != 'not_closed'">
                                <img src="@/assets/icons/ic_x_airlead.svg"><span>{{translate('airLeadDashboardNotClosed')}}</span>
                            </b-dropdown-item>
                            <b-dropdown-item @click.stop="onStatusSelected(item, 'closed')"
                                             v-if="item.status != 'closed'">
                                <img src="@/assets/icons/ic_checkbox_marked_airlead.svg"><span>{{translate('airLeadDashboardClosedWon')}}</span>
                            </b-dropdown-item>
                            <b-dropdown-item @click.stop="onStatusSelected(item, 'not_qualified')"
                                             v-if="item.status != 'not_qualified'">
                                <img src="@/assets/icons/ic_not_qualified.svg"><span>{{translate('airLeadDashboardNotQualified')}}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </td>
                    <td @click="onStatusNotesClick(item)" style="white-space: pre-wrap; cursor: pointer"><textarea
                        :ref="`status_input_${item.guid}`"
                        :placeholder="translate('airLeadDashboardStatusNotes')" v-if="item.showStatusEdit" v-model="item.status_notes"
                        class="status-notes-input"></textarea>
                        <span>{{ item.status_notes }}</span>
                    </td>
                    <td style="cursor: pointer" @click="onQtyClick(item)"><input
                        min="0"
                        max="20"
                        :ref="`commission_input_${item.guid}`"
                        v-on:keyup.enter="hideUnderlay(item)"
                        :placeholder="translate('airLeadDashboardQuantity')" type="number" v-if="item.showQtyEdit" v-model="item.items_amount"
                        class="commission-input"
                        >
                        {{ item.items_amount == 0 ? '' : item.items_amount }}
                    </td>
                    <td>{{ item.commission == 0 ? '' : '$' + item.commission }}</td>
                    <td><span v-if="item.last_action_by">{{item.last_action_date | moment("MM/DD/YYYY HH:mm")}}</span></td>
                    <td style="white-space: pre-wrap;">{{ getActionBy(item) }}</td>
                    <td style="cursor: pointer" class="last-col" @click="saveClick(item)" :class="{active : item.status_notes !== item.initialValues.status_notes || ((item.items_amount == '' ? 0 : item.items_amount) !== item.initialValues.items_amount) || item.status !== item.initialValues.status}">
                        <img class="save_image" :class="{active : item.status_notes !== item.initialValues.status_notes || ((item.items_amount == '' ? 0 : item.items_amount) !== item.initialValues.items_amount) || item.status !== item.initialValues.status}"
                                                v-if="item.current_user_assignee" src="@/assets/icons/ic_save_airLead.svg" alt="">
                    </td>
                </tr>
            </table>
            <infinite-loading :identifier="infiniteId" @infinite="loadLinks" ref="infinite-loading">
                <div slot="no-more"></div>
                <div slot="no-results" class="infinite-no-results">
                    <span>{{translate('airLeadDashboardNotLeadsFound')}}</span>
                    <b-button v-if="!fetchAll" @click="fetchAll = true; hideClosed = false">{{translate('airLeadShowAllLeads')}}</b-button>
                </div>
            </infinite-loading>
        </div>
        <div @click="refreshAll" class="refresh-btn">{{translate('airLeadDashboardRefresh')}}</div>
        <div class="top-items-underlay" v-if="underlay.show" @click="onUnderlayClick"></div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import customModalDialog from '@/components/widgets/customModalDialog';
import airLeadInfoPopup from '@/components/widgets/airLeadInfoPopup'
import moment from 'moment'
import errorMixin from '@/mixins/errorMixin';

export default {
    name: 'airleadsDashboard',
    mixins: [errorMixin],
    components: {
        InfiniteLoading,
        customModalDialog,
        airLeadInfoPopup
    },
    data() {
        return {
            leads: [],
            page: 1,
            counter: 0,
            fetchAll: this.isUserOwner() || this.isUserOrgManager(),
            hideClosed: localStorage.getItem('airlead_hide_closed_flag', false),
            infiniteId: +new Date(),
            underlay: {
                show: false,
                editableItem: null
            },
            loadingAction: false,
            customModalSettings: {},
            airLeadInfoPopupSettings: {}
        }
    },
    computed: {
        ...mapState({
            accounts: state => state.closeAccount.accounts,
            userInfo: state => state.auth.userInfo,
        })
    },
    watch: {
        fetchAll(item) {
            this.refreshAll()
        },
        hideClosed(item) {
            this.refreshAll()
            localStorage.setItem('airlead_hide_closed_flag', item)
        },
    },
    mounted() {
    },
    methods: {
        ...mapGetters({
            isUserOwner: 'auth/isUserOwner',
            isUserOrgManager: 'auth/isUserOrgManager'
        }),
        ...mapActions({
            getAirLeads: 'airLead/getAirLeads',
            saveAirLead: 'airLead/saveAirLead'
        }),

        ...mapMutations({
            setMessageModel: 'setMessageModel',
            setProgressBarTag: 'setProgressBarTag',
        }),

        async refreshAll() {
            this.leads = []
            this.page = 1
            this.infiniteId += 1
        },

        async loadLinks(stateInf) {
            try {
                console.log(`loadLinks`)
                this.loadingAction = true
                const response = await this.getAirLeads({
                    page: this.page,
                    fetch_all: this.fetchAll,
                    hide_closed: this.hideClosed
                })
                if (this.page == 1) {
                    this.leads = []
                }
                this.page += 1;
                let items = response.airleads
                for (let i = 0; items.length > i; i++) {
                    items[i].showStatusEdit = false
                    items[i].showQtyEdit = false
                    items[i].initialValues = {
                        status: items[i].status,
                        items_amount: items[i].items_amount,
                        status_notes: items[i].status_notes,
                    }
                }
                items.forEach((item) => {
                    this.leads.push(item)
                })
                if (stateInf) {
                    if (items.length > 0) stateInf.loaded();
                    if(items.length < 1000) stateInf.complete();
                }
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loadingAction = false
            }
        },

        getTypeText(type) {
            switch (type) {
                case 'new': {
                    return 'N'
                }
                case 'existing': {
                    return 'E'
                }
                default: {
                    return ''
                }
            }
        },
        getStatusName(status) {
            switch (status) {
                case 'closed': {
                    return 'Closed/Won'
                }
                case 'not_closed': {
                    return 'Not Closed'
                }
                default: {
                    return 'Sales followup'
                }
            }
        },
        getRef(guid) {
            let ref = 'status_dropdown_' + guid
            console.log(ref)
            return ref
        },
        isLeadFinished(status) {
            return status == 'closed' || status == 'not_closed'
        },
        getLastActionDate(item) {
            return item.last_action_by ? moment(item.last_action_date * 1000).format("MM/DD/YYYY HH:mm") : ''
        },
        getActionBy(item) {
            if (item.last_action_by) {
                return item.last_action_by.first_name + ' ' + item.last_action_by.last_name
            } else {
                let str = ''
                item.assignees.forEach((assignee, index) => {
                    if (index != 0) str += '\n'
                    str += assignee.first_name + ' ' + assignee.last_name
                })
                return str
            }
        },
        onStatusClick(item) {
            console.log(`lel`)
            if(!item.current_user_assignee) return
            var value = this.getItemByRef(`status_dropdown_${item.guid}`)
            value.show()
            this.showUnderlay(item)
        },
        getItemByRef(ref) {
            console.log(this.$refs)
            var value = this.$refs[ref]
            if (Array.isArray(value)) value = value[0]
            return value
        },
        onStatusSelected(item, newStatus) {
            item.status = newStatus
            this.hideUnderlay()
        },
        onStatusNotesClick(item) {
            if(!item.current_user_assignee) return
            item.showStatusEdit = true
            this.showUnderlay(item)
            setTimeout(()=>{
                let value = this.getItemByRef(`status_input_${item.guid}`)
                value.focus()
            },200);
        },
        onQtyClick(item) {
            if(!item.current_user_assignee) return
            item.showQtyEdit = true
            this.showUnderlay(item)
            setTimeout(()=>{
                let value = this.getItemByRef(`commission_input_${item.guid}`)
                value.focus()
                value.select()
            },200);
        },
        onUnderlayClick() {
            this.hideUnderlay()
        },
        hideUnderlay() {
            this.underlay.show = false
            this.underlay.editableItem.showStatusEdit = false
            let qty = this.underlay.editableItem.items_amount
            if (this.underlay.editableItem.showQtyEdit) {
                if(qty < 0 || qty >= 20) {
                    if(qty < 0) this.showErrorModal('Quantity should be greater than 0')
                    if (qty.length >3) this.showErrorModal('Quantity should be less than 20')
                    this.underlay.editableItem.items_amount = 0
                } else {
                    let commission = this.underlay.editableItem.commission
                    if(this.underlay.editableItem.type == 'existing') {
                        commission = qty * 15.0;
                    } else {
                        commission = qty * 25.0;
                    }
                    this.underlay.editableItem.commission = commission
                }
            }
            this.underlay.editableItem.showQtyEdit = false

        },
        showUnderlay(editableItem) {
            this.underlay.editableItem = editableItem
            this.underlay.show = true
        },
        showLeadInfo(leadInfo) {
            let data = JSON.parse(leadInfo.data)
            if(leadInfo.type == 'new') {
                this.airLeadInfoPopupSettings = {
                    show: true,
                    type: leadInfo.type,
                    airlead: true,
                    title: `AirLead #${leadInfo.id}`,
                    driver: leadInfo.creator_name,
                    company_name: data.company_name,
                    phone: data.phone,
                    site_type: data.site_type,
                    opportunity: data.opportunity,
                    notes: leadInfo.notes,
                    location : leadInfo.location,
                    images: leadInfo.attachments.images,
                    audio: leadInfo.attachments.audio
                }
            } else {
                this.airLeadInfoPopupSettings = {
                    show: true,
                    airlead: true,
                    title: `AirLead #${leadInfo.id}`,
                    driver: leadInfo.creator_name,
                    customer_id: data.customer_id,
                    services: data.services,
                    notes: leadInfo.notes,
                    location : leadInfo.location,
                    images: leadInfo.attachments.images,
                    audio: leadInfo.attachments.audio
                }
            }
            
        },
        saveClick(item) {    
            if(item.status == 'closed' && (item.status_notes == '' || item.items_amount == 0)) {
                this.showErrorModal(this.translate('airLeadStatusAndCommissionError'))
            } else if (item.status == 'not_closed' && item.status_notes == '') {
                this.showErrorModal(this.translate('airLeadStatusNotesError'))
            } else {
                this.saveAirLeadAction(item)
            }
        },
        async saveAirLeadAction(item) {
            let airlead_guid = item.guid
            let data = {
                status: item.status,
                status_notes: item.status_notes,
                items_amount: item.items_amount
            }
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'add_airlead_dashboard'
                })
                const response = await this.saveAirLead({airlead_guid, data})
                item.initialValues = {
                    status: item.status,
                    items_amount: item.items_amount == '' ? 0 : item.items_amount,
                    status_notes: item.status_notes,
                }
                
                    item.commission = response.commission
                    item.last_action_date = response.last_action_date
                    item.last_action_by = response.last_action_by
                this.underlay.editableItem = null
                this.showErrorModal(this.translate('manageSaved') + '!', {duration: 3000})
            } catch (error) {
                this.showErrorModal(error.data.error.message, {
                        title: 'Error',
                        code: error.data.error.code
                    })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'add_airlead_dashboard'
                })
            }
        },
    }
}
</script>

<style scoped>
.airlead-header {
    display: flex;
    justify-content: end;
}
.airlead-title {
    font-size: 28px;
    margin-top: 24px;
}
.fetch-new-wrapper {
    display: flex;
    align-items: end;
    margin-right: 24px;
}
.fetch-all-wrapper {
    display: flex;
    align-items: end;
}
.infinite-no-results {
    padding-top: 24px;
    padding-bottom: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.infinite-no-results span {
    color: #4e4e4e;
}
.infinite-no-results button {
    margin-top: 16px;
}
.refresh-btn {
    cursor: pointer;
    color: #4A85CB;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-top: 15px;
    padding-right: 15px;
}
.first-col {
    color: #4A85CB;
    text-decoration: underline;
}
.status-dropdown img, .status-cell img {
    width: 24px;
    height: 24px;
}
</style>
<style>
.fetch-all-wrapper .custom-control-label {
    font-size: 18px !important;
    padding-left: 8px;
    color: #4e4e4e;
}
.fetch-new-wrapper .custom-control-label {
    font-size: 18px !important;
    padding-left: 8px;
    color: #4e4e4e;
}
.main-container {
    position: fixed;
    max-width: 1280px;
    width: 95%;
    height: 80%;
    margin-top: 16px;
    background: #F3F3F3;
}

.airleads-container {
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
    margin-top: 16px;
    width: 100%;
    margin-right: 16px;
    border-radius: 4px;
    min-height: 150px;
    overflow-x: auto;
    overflow-y: scroll;
    max-height: 95%;
    background: #ffffff;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.airleads-table {
    min-width: 100%;
    margin-top: 16px;
    border-collapse: collapse;
}

.table-header {
    position: sticky;
    top: 0;
    padding-top: 0;
    background: #ffffff;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
    z-index: 100;
    border-top: none !important;
    color: black;
    background-color: #b9d99c;
}

.airleads-table .table-row {
    background: white;
    border-top: solid 1px rgba(109, 109, 109, 0.51);
    border-bottom: solid 1px rgba(109, 109, 109, 0.51);
    color: #2F2F2F;
}

.airleads-table .table-row.finished {
    background: rgb(243, 243, 243);
}

.airleads-table .table-row:hover {
    background: #FFEDC2FF;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.airleads-table td {
    vertical-align: baseline;
    text-align: start;
    padding: 6px;
    position: relative;
    border-right: solid 1px rgba(109, 109, 109, 0.51);
    border-left: solid 1px rgba(109, 109, 109, 0.51);
}

.first-col {
    border-left: none !important;
}

.last-col {
    border-right: none !important;
    pointer-events: none;
    cursor: pointer;
}
.last-col.active{
    pointer-events: inherit;
}

.place-org-td:hover > .place-org-content {
    background: #FFEDC2FF;
    overflow-x: visible;
    padding-right: 5px;
    max-width: 500px;
    height: auto;
    position: absolute;
    z-index: 90;
}

.place-org-content {
    overflow-x: hidden;
    white-space: nowrap;
    max-width: 150px;
    height: 100%;
}

.status-dropdown {
    position: absolute;
}
.status-dropdown img{
    margin-right: 8px;
    margin-left: -12px;
}

.status-notes-input {
    position: absolute;
    width: 400px;
    z-index: 250;
    height: 150px;
    text-align: start;
    alignment: top;
}

.top-items-underlay {
    z-index: 200;
    background: rgba(0, 0, 0, 0.38);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
}

.commission-input {
    position: absolute;
    width: 60px;
    z-index: 250;
}

.save_image {
    opacity: 0.5;
}
.save_image.active {
    opacity: 1;
}
</style>